import React from 'react'

import PerfectScrollBar from 'react-perfect-scrollbar'
import moment from 'moment'
import { reverse } from 'named-urls'
import { useHistory } from 'react-router-dom'

import { Box, Button, Divider, Paper, Typography } from '@material-ui/core'

import { routes } from 'routes'
import { DotStatus } from 'components'
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  TablePagination,
} from 'components/Table'
import { Permitted } from 'components/Permissions'
import * as service from 'service'
import helpers from 'helpers'
import useEmbeddedList from 'hooks/useEmbeddedList'

const TableRowInvoice = ({ invoice }) => (
  <TableRow to={reverse(routes.invoices.show, { invoiceId: invoice.id })} hover>
    <TableCell>{invoice.identifier}</TableCell>
    <TableCell>{moment(invoice.createdAt).format('DD/MM/YYYY')}</TableCell>
    <TableCell>{moment(invoice.dueDate).format('DD/MM/YYYY')}</TableCell>
    <TableCell align="center">
      {invoice.paidAt ? moment(invoice.paidAt).format('DD/MM/YYYY') : '-'}
    </TableCell>
    <TableCell align="right">{helpers.currency(invoice.amountDue)}</TableCell>
    <TableCell align="center">
      <DotStatus
        statusName={helpers.invoices.status(invoice.status)}
        statusTag={invoice.status}
        entity="invoice"
      />
    </TableCell>
  </TableRow>
)

const InvoiceInfo = ({ contractId, status }) => {
  const history = useHistory()

  const handleNewInvoice = () => {
    history.push(reverse(routes.contractInvoices.new, { contractId }))
  }

  const {
    response: responseInvoices,
    isLoading: isLoadingInvoices,
    pagination,
  } = useEmbeddedList(service.recurrence.invoices.getByContract, {
    contractId,
    page: 1,
    perPage: 5,
  })

  return (
    <Paper>
      <Box
        p={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h4">Faturas</Typography>

        {status === 'active' ? (
          <Permitted tag="create_invoice">
            <Button
              variant="outlined"
              onClick={handleNewInvoice}
              color="primary"
            >
              Incluir
            </Button>
          </Permitted>
        ) : null}
      </Box>

      <Divider />

      <PerfectScrollBar>
        <Table
          emptyMessage="Não há faturas geradas para esta assinatura"
          isLoading={isLoadingInvoices}
          noWrap
        >
          <TableHead>
            <TableRow>
              <TableCell>Identificador</TableCell>
              <TableCell>Data de emissão</TableCell>
              <TableCell>Vencimento</TableCell>
              <TableCell align="center">Data de pagamento</TableCell>
              <TableCell align="right">Valor</TableCell>
              <TableCell align="center">Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {responseInvoices &&
              responseInvoices.data.invoices.map((invoice, index) => (
                <TableRowInvoice invoice={invoice} key={index} />
              ))}
          </TableBody>
        </Table>
      </PerfectScrollBar>

      {responseInvoices && (
        <Box px={2}>
          <TablePagination
            component="div"
            count={responseInvoices.data.meta.totalCount}
            onChangePage={pagination.handleChangePage}
            onChangeRowsPerPage={pagination.handleChangeRowsPerPage}
            page={pagination.page}
            rowsPerPage={pagination.perPage}
            rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
            nextIconButtonProps={{ size: 'small' }}
            backIconButtonProps={{ size: 'small' }}
          />
        </Box>
      )}
    </Paper>
  )
}

export default InvoiceInfo
